import { Popup } from "react-map-gl";
import styled from "styled-components";

import { ToolTipStyles } from "shared/components/Tooltip/styles";
import { slideInFromBottomKeyframes, space } from "shared/styles/constants";

export const StyledTooltip = styled(Popup)`
  animation: ${slideInFromBottomKeyframes} 300ms ease-in-out;

  .mapboxgl-popup-content {
    ${ToolTipStyles}

    display: flex;
    padding: ${space.xs} !important;
    border-radius: 0;
    max-width: 200px;
  }
`;
